<app-hourglass *ngIf="hourglass"></app-hourglass>
    <span mat-dialog-title>New entry for {{ currentGroup.name }}</span>
    <app-timezone (selectedEvent)="handleTimezoneChange($event)" [defaultId]="timezone ? timezone.id : intlForHTML.DateTimeFormat().resolvedOptions().timeZone"
                  [disabled]="disabled" id="selectedTimezone"></app-timezone>
<mat-dialog-content class="mat-dialog-content">
    <div class="row-flex">
        <div class="row-flex-2">
            <div class="entry-labels">
                <label class="mt10">Entry Name: </label>
            </div>
            <mat-form-field class="w50">
                <input [(ngModel)]="entryName" maxlength="300" id="entryName" class="w50" matInput required>
            </mat-form-field>
        </div>
    </div>
    <div class="row-flex-2">
        <div class="entry-labels">
            <label class="mt10">Entry Times: </label>
        </div>
        <div class="entry-time"*ngIf="timezone">
            <app-date-interval-time-picker
                hint="Start Time and Date."
                timezone="{{timezone.id}}"
                [required]="true"
                (dateChange)="startDate = $event"
                id="dateStartIntervalPicker"
                idSuffix="Start">
            </app-date-interval-time-picker>
        </div>
        <div class="entry-time" *ngIf="timezone">
            <app-date-interval-time-picker
                hint="End Time and Date."
                timezone="{{timezone.id}}"
                [required]="false"
                (dateChange)="endDate = $event"
                id="dateEndIntervalPicker"
                idSuffix="End"
                [endDate]="true">
            </app-date-interval-time-picker>
        </div>
        <div class="entry-type">
            <mat-form-field>
                <mat-select [(value)]="scheduleType" [(ngModel)]="scheduleType" id="scheduleType">
                    <mat-option *ngFor="let freq of repeatTypes; let i = index" [value]="freq" id="repeatfreqTypes{{i}}">{{freq}}</mat-option>
                </mat-select>
                <mat-hint>Repeat Frequency:</mat-hint>
            </mat-form-field>
        </div>
        <div *ngIf="scheduleType === 'Weekly'" class="day-select" id="day-select">
            <div (click)="day.select = !day.select" *ngFor="let day of daysOfWeek; let i = index" id="daysOfWeekSelection{{i}}"
                 [class]="day.select === true ? 'per-day-active' : 'per-day-inactive'">
                {{day.day}}
            </div>
        </div>
    </div>
    <div class="row-flex-2">
        <div class="entry-labels">
            <label class="mt10">Participants: </label>
        </div>
        <mat-form-field class="participant-type">
            <mat-select [(ngModel)]="participantType" id="participantType">
                <mat-option *ngFor="let pType of participantTypes; let i = index" [value]="pType" id="pTypeSelection{{i}}">
                    {{pType}}
                </mat-option>
            </mat-select>
            <mat-hint>Participant Type</mat-hint>
        </mat-form-field>
        <div class="col-flex">
            <div class="participant-field" id="newParticipants">
                <mat-chip-list (cdkDropListDropped)="drop($event)" cdkDropList cdkDropListOrientation="vertical" id="participantsList">
                    <mat-chip (removed)="removeParticipant(participant)"
                              *ngFor="let participant of participantList; let i = index" cdkDrag class="w100" id="removeParticipant{{i}}">
                        <div class="participant-chip" id="participant-chip{{i}}">
                            {{participant.participant_name}}
                            <div class="input-row" matTooltip="Enter duration in hours">
                                Duration:
                                <input [(ngModel)]="participant.duration"
                                       (ngModelChange)="participant.duration = makeEvenMultiple(participant.duration)"
                                       (keydown)="onChangeDuration($event)" class="participant-chip-duration text-current bg-transparent"
                                       min=".25" step=".25" type="number" id="participantDuration"/>
                                <mat-icon id="matChipRemove{{i}}" matChipRemove>cancel</mat-icon>
                            </div>
                        </div>
                    </mat-chip>
                </mat-chip-list>
            </div>
            <mat-form-field class="participant-field">
                <input [(ngModel)]="participantInput"
                       (input)="isGroup() ? grpChange(participantInput) : indChange(participantInput)"
                       [matAutocomplete]="autoIndividual" matInput id="participantInput"/>
                <mat-autocomplete #autoIndividual="matAutocomplete"
                                  (optionSelected)="setupParticipant($event.option.value);"
                                  autoActiveFirstOption id="participantOption">
                    <mat-option *ngFor="let participant of autocompleteIndOrDevice; let i = index" [value]="participant" id="participantSelection{{i}}">
                        {{ participant.full_name ? participant.full_name : participant.name }} </mat-option>
                </mat-autocomplete>
                <mat-placeholder>
                    <mat-icon id="searchNewParticipant">search</mat-icon>
                    New Participant
                </mat-placeholder>
                <mat-hint>Search for new {{isGroup() ? 'group' : 'individual or channel'}} to add to entry
                </mat-hint>
            </mat-form-field>

        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions" id="dailogActions">
    <button (click)="save()" color="primary" id="newEntrySave" mat-raised-button>Save</button>
    <button [mat-dialog-close]="closeDialog" id="newEntryCancel" color="primary" mat-raised-button>Cancel</button>
</mat-dialog-actions>
